import { useMemo, useCallback } from "react";
import { useQuery } from "@apollo/client";
import { HERO_LIST } from "./queries";
import heroPath from "./heroPath";

export default function useHeroPath() {
    const { data } = useQuery(HERO_LIST);

    const multiRoleSet = useMemo(() => {
        if (!data) return new Set();
        const counts = {};
        data.heroList.forEach(({ hero }) => {
            counts[hero] = (counts[hero] || 0) + 1;
        });
        return new Set(Object.keys(counts).filter((h) => counts[h] > 1));
    }, [data]);

    return useCallback(
        (heroName, role) => heroPath(heroName, multiRoleSet.has(heroName) ? role : null),
        [multiRoleSet],
    );
}
